import { render, staticRenderFns } from "./ProfileAccessManage.vue?vue&type=template&id=642f0efc&"
import script from "./ProfileAccessManage.vue?vue&type=script&lang=js&"
export * from "./ProfileAccessManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642f0efc')) {
      api.createRecord('642f0efc', component.options)
    } else {
      api.reload('642f0efc', component.options)
    }
    module.hot.accept("./ProfileAccessManage.vue?vue&type=template&id=642f0efc&", function () {
      api.rerender('642f0efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/ProfileAccessManage.vue"
export default component.exports